module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8c6be33fc9a8eadffa880c9fe0ca6340.png";